<template>
  <!--    首页单屏-->
  <div class="banner">
    <div class="cover">
      <div class="cover-text">
        <div class="main">{{ $t("jrwm") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.cover {
  position: relative;
  width: 100%;
  height: 30rem;
  min-height: 30rem;
  overflow: hidden;
  background: url("~@/assets/images/joinUs/banner.png") no-repeat top;
  background-size: cover;
}
.cover-text {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  color: #fff;
  text-align: center;
  transform: translate(-50%, -50%);

  .main {
    font-size: 2.1rem;
    font-weight: bold;
    color: #ffffff;
    letter-spacing: 2px;
  }
}
</style>
